
import React from "react";
import MainLayout from "@/layout/MainLayout";

const TermsOfService: React.FC = () => {
  return (
    <MainLayout>
      <div className="bg-white min-h-screen text-black">
        <div className="container mx-auto px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-semibold mb-8 text-black">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none text-black">
          <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">1. Agreement to Terms</h2>
          <p>
            By accessing or using HeyVail's website and services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with these Terms, you should not use our services.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">2. Description of Services</h2>
          <p>
            HeyVail provides AI-powered lead generation and qualification services. Our platform helps businesses identify, engage, and qualify potential leads through various channels including SMS, chat, and calls.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">3. User Accounts</h2>
          <p>
            To access certain features of our services, you may need to create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">4. Acceptable Use</h2>
          <p>You agree not to use our services to:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Violate any laws or regulations</li>
            <li>Infringe on the rights of others</li>
            <li>Send spam or unsolicited messages</li>
            <li>Distribute malware or other harmful content</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Interfere with the proper functioning of our services</li>
          </ul>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">5. Intellectual Property</h2>
          <p>
            All content, features, and functionality of our services, including but not limited to text, graphics, logos, and software, are owned by HeyVail or its licensors and are protected by copyright, trademark, and other intellectual property laws.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">6. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, HeyVail shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">7. Termination</h2>
          <p>
            We may terminate or suspend your access to our services immediately, without prior notice or liability, for any reason, including but not limited to a breach of these Terms.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">8. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will provide notice of significant changes by updating the "Last updated" date at the top of these Terms.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">9. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the State of Delaware, without regard to its conflict of law provisions.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">10. Contact Information</h2>
          <p>
            If you have any questions about these Terms, please contact us at legal@heyvail.com.
          </p>
        </div>
      </div>
    </div>
    </MainLayout>
  );
};

export default TermsOfService;
